import React, { ReactNode, CSSProperties } from "react";

interface OverlayContainerProps {
    background: ReactNode;                      // anything — image, video, etc.
    children?: ReactNode;                       // overlay content
    height?: string | number;                   // container height
    position?: CSSProperties["justifyContent"]; // horizontal alignment
    align?: CSSProperties["alignItems"];        // vertical alignment
    className?: string;
    style?: CSSProperties;
}

const OverlayContainer: React.FC<OverlayContainerProps> = ({
                                                               background,
                                                               children,
                                                               height,
                                                               className,
                                                               style,
                                                           }) => {
    return (
        <div
            className={className}
            style={{
                position: "relative",
                display: "flex",
                // justifyContent: position,
                // alignItems: align,
                height: typeof height === "number" ? `${height}px` : height,
                overflow: "hidden",
                ...style,
            }}
        >
            {/* Background node */}
            <div
                style={{
                    width: "100%",
                    height: "100%",
                }}
            >
                {background}
            </div>

            {/* Overlayed child */}
            {children}
        </div>
    );
};

export default OverlayContainer;
